import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { ErrorBoundaryView } from './ErrorBoundaryView';
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }
    setHasError = () => {
        this.setState({
            hasError: false,
        });
    };
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error,
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Error on Rendering', error, errorInfo);
        // TODO: Add logger to track errors in Kibana Monitoring. Create a log endpoint in data-service to use the already existing logger.
        this.setState({ errorInfo, error });
    }
    render() {
        if (this.state.hasError) {
            return (_jsx(ErrorBoundaryView, { hasError: this.state.hasError, setHasError: this.setHasError, error: this.state.error }));
        }
        return this.props.children;
    }
}
